var _templateObject;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React, { useEffect } from 'react';
import gql from 'graphql-tag';
import OffMarketContactAgentForm from '@zillow/off-market-contact-agent-form';
import { useQuery, useApolloClient } from '@apollo/client';
import { REQUIRED_PROPERTY_DIMENSIONS_FRAGMENTS } from '@zillow/universal-analytics-react';
import { Spinner } from '@zillow/constellation';
import styled from 'styled-components';
import ErrorMessage from './ErrorMessage';
import HomeInfo from './HomeInfo';
import ErrorWrapper from './ErrorWrapper';
import ResponsiveLightbox from './ResponsiveLightbox';
import OmpHomeWorthUpsell from './OmpHomeWorthUpsell';
import HomeDetailLightboxContent from './HomeDetailLightboxContent';

function getQuery() {
  return gql(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n        query HowMuchIsMyHomeWorthReviewQuery($zpid: ID!) {\n            property(zpid: $zpid) {\n                streetAddress\n                city\n                state\n                zipcode\n                bedrooms\n                bathrooms\n                livingArea\n                zestimate\n                homeStatus\n                photos(size: XL) {\n                    url\n                }\n                ...OmpHomeWorthUpsell_property\n                isConfirmedClaimedByCurrentSignedInUser\n                isVerifiedClaimedByCurrentSignedInUser\n                ...UARequiredPropertyDimensions_property\n                ...ContactAgentForm_property\n                ...HomeInfo_property\n            }\n            viewer {\n                ...ContactAgentForm_viewer\n            }\n            abTests {\n                ...OmpHomeWorthUpsell_abTests\n                ...UARequiredPropertyDimensions_abTests\n                ...ContactAgentForm_abTests\n            }\n        }\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n    "])), OmpHomeWorthUpsell.fragments.property, OmpHomeWorthUpsell.fragments.abTests, REQUIRED_PROPERTY_DIMENSIONS_FRAGMENTS.property, REQUIRED_PROPERTY_DIMENSIONS_FRAGMENTS.abTests, OffMarketContactAgentForm.fragments.property, OffMarketContactAgentForm.fragments.viewer, OffMarketContactAgentForm.fragments.abTests, HomeInfo.fragments.property);
}

var StyledResponsiveLightbox = styled(ResponsiveLightbox).withConfig({
  displayName: "HomeDetailLightbox__StyledResponsiveLightbox",
  componentId: "sc-1n6rrq-0"
})(["align-items:center;height:626px;display:flex;justify-content:center;"]);
export var StyledLoadingContent = function StyledLoadingContent(_ref) {
  var isLightboxBackgroundLocked = _ref.isLightboxBackgroundLocked;
  return /*#__PURE__*/React.createElement(StyledResponsiveLightbox, {
    isLightboxBackgroundLocked: isLightboxBackgroundLocked
  }, /*#__PURE__*/React.createElement(Spinner, {
    size: "lg",
    "data-testid": "loading-status"
  }));
};
export var StyledErrorContent = function StyledErrorContent() {
  return /*#__PURE__*/React.createElement(ErrorWrapper, null, /*#__PURE__*/React.createElement(ErrorMessage, {
    shouldShowRefreshPagePrompt: true
  }, "Looks like we're unable to get information for your home's listing right now."));
};

var HomeDetailLightbox = function HomeDetailLightbox(props) {
  var client = useApolloClient();
  var query = getQuery(); // TODO: remove "client" from useQuery call and default to client provided by context provider
  // https://www.apollographql.com/docs/react/data/queries/#client

  var zpid = props.zpid,
      setHmimhwAnalyticsData = props.setHmimhwAnalyticsData,
      isLightboxBackgroundLocked = props.isLightboxBackgroundLocked;

  var _useQuery = useQuery(query, {
    variables: {
      zpid: zpid
    },
    client: client
  }),
      data = _useQuery.data,
      loading = _useQuery.loading,
      error = _useQuery.error;

  useEffect(function () {
    if (typeof setHmimhwAnalyticsData === 'function' && !loading && !error && data) {
      setHmimhwAnalyticsData(data);
    }
  }, [setHmimhwAnalyticsData, loading, error, data]);

  if (loading) {
    return /*#__PURE__*/React.createElement(StyledLoadingContent, {
      isLightboxBackgroundLocked: isLightboxBackgroundLocked
    });
  }

  if (error || !(data !== null && data !== void 0 && data.property)) {
    return /*#__PURE__*/React.createElement(StyledErrorContent, null);
  }

  return /*#__PURE__*/React.createElement(HomeDetailLightboxContent, _extends({}, props, data));
};

export default HomeDetailLightbox;
//# sourceMappingURL=HomeDetailLightbox.js.map